import { logger } from './logger';
const FILE_ID_PATTERN = /^[A-Za-z0-9_.-]+$/;

function debugFileId(label: string, fileId: string | null | undefined) {
  logger.debug(label, {
    raw: fileId,
    json: JSON.stringify(fileId),
    length: fileId?.length,
    // @ts-ignore Required to keep the requested debug snippet unchanged on the current ES5 target.
    charCodes: [...(fileId || '')].map(ch => ch.charCodeAt(0)),
  });
}

function getFileIdCharCodes(fileId: string | null | undefined): number[] {
    const rawFileId = typeof fileId === 'string' ? fileId : '';
    return Array.from(rawFileId).map(ch => ch.charCodeAt(0));
}

function logInvalidFileId(source: string, fileId: string | null | undefined): void {
    logger.error(`Invalid fileId at ${source}`, {
        fileId: JSON.stringify(fileId),
        charCodes: getFileIdCharCodes(fileId)
    });
}

function isValidFileId(fileId: string | null | undefined): fileId is string {
    return typeof fileId === 'string' && FILE_ID_PATTERN.test(fileId);
}

function assertValidFileId(fileId: string | null | undefined, source: string): asserts fileId is string {
    if (!isValidFileId(fileId)) {
        logInvalidFileId(source, fileId);
        throw new Error(`Ongeldige fileId gedetecteerd in ${source}. Upload geblokkeerd.`);
    }
}

export {
    FILE_ID_PATTERN,
    debugFileId,
    isValidFileId,
    assertValidFileId,
    logInvalidFileId
};
